<template>
  <m-select
    :open="open"
    :value="selectedOptions"
    :items="options"
    :grouped-items="groupedOptions"
    :read-only="readOnly"
    :value-key="valueKey"
    :item-text="itemText"
    :max-tag-text-length="maxTagTextLength"
    full-width
    tags
    multiple
    :placeholder="$t('optionScope.placeholder')"
    keep-open-on-click
    return-object
    @update:open="emit('update:open', $event)"
    @update:value="updateSelectedOptions"
  >
    <template #trigger>
      <slot name="trigger" />
    </template>
    <template #overlay-header>
      <m-content :padding-top="4">
        <m-content :padding-x="5">
          <quick-filter-header
            :label="scopeItem.text"
            @delete="emit('delete')"
            @add-to-advanced="emit('addToAdvanced')"
          >
            <template #op>
              <m-select
                :value="selectedType"
                :items="operatorTypes"
                :read-only="readOnly"
                xs
                hide-border
                light
                :trigger-style="{ textTransform: 'lowercase' }"
                @input="updateSelectedType"
              />
            </template>
          </quick-filter-header>
        </m-content>
      </m-content>
    </template>
    <template #item="item">
      <status-item
        small
        :selected-option="getSelectedOptionFromItem(item)"
      />
    </template>
  </m-select>
</template>

<script setup>
import QuickFilterHeader from '@/components/filter/quick/QuickFilterHeader.vue';
import StatusItem from '@/components/goal/StatusItem.vue';
import useGoalProperty from '@/composables/property/goal-property';
import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import useScopeItem from '@/composables/filter/scope-item';
import useStatusProperty from '@/composables/goal/status-property';
import { AND, NOT } from '@/lib/filter/scope-tree';
import { computed } from 'vue';
import { propertyType } from 'shared/constants.json';

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  scopeItem: {
    type: Object,
    required: true,
  },
  node: {
    type: Object,
    required: true,
  },
  readOnly: {
    type: Boolean,
    default: false,
  },
  valueKey: {
    type: String,
    default: 'uid',
  },
  itemText: {
    type: String,
    default: 'label.en',
  },
  maxTagTextLength: {
    type: Number,
    default: 0,
  },
});
const emit = defineEmits(['update:open', 'update:scope', 'update:not-operator', 'delete', 'addToAdvanced']);

const { operatorTypes: getOperatorTypes } = useScopeItem();
const operatorTypes = getOperatorTypes(propertyType.status, { hideEmpty: true });

const { userLang } = useLoggedInUser();
const { statusProperty: statusProp } = useGoalProperty();
const { leafOptions: options, groupedOptions } = useStatusProperty(statusProp, userLang);

const getSelectedOptionFromItem = (item) => {
  if (item.isTrigger) {
    return options.value.find((o) => o.uid === item.item.uid);
  }
  return options.value.find((o) => o.uid === item.item);
};

const scope = computed(() => props.node.children[0].scope);

const selectedType = computed(() => props.node.op);
const updateSelectedType = (value) => {
  if (value === NOT) {
    emit('update:not-operator', NOT);
    return;
  }
  emit('update:not-operator', AND);
};

const selectedOptions = computed(() => scope.value.selectedOptions);
const updateSelectedOptions = (value) => {
  if (JSON.stringify(selectedOptions.value) === JSON.stringify(value)) {
    return;
  }
  emit('update:scope', { ...scope.value, selectedOptions: value });
};

</script>

<style scoped lang="scss">
</style>
